// eslint-disable-next-line import/named
import { IUser, User, UserResponse } from "../coworkerApiCalls/User/UsersTypes";

const userResponseToUser = (user: UserResponse): User => {
  return {
    lastName: user.lastName,
    firstName: user.firstName,
    oktaUid: user.oktaUid,
    idDepartment: Number(user.departmentId),
    idRole: Number(user.roleId),
    isInternal: Boolean(user.isInternal),
    defaultSpace: Number(user.defaultSpace)
  };
};

const userResponseToIUser = (user: UserResponse): IUser => {
  return {
    id: user.id,
    oktaUid: user.oktaUid,
    lastName: user.lastName,
    firstName: user.firstName,
    idDepartment: Number(user.departmentId),
  };
};

export { userResponseToUser, userResponseToIUser };